import { Comparable } from '../utils/comparable';

export class State implements Comparable<State> {
    public static readonly SC = new State(1, 1, 'Santa Catarina', 'SC');

    public static getStateByCode(states: State[], stateId: number|string|any): State  {
        return states.find(state => state.state_id == (stateId?.state_id || stateId));
    }

    constructor(
        public state_id: number,
        public country_id: number,
        public state_name: string,
        public acronym: string){}

    compareTo(other: State): number {
        if (this.state_id == other.state_id) {
            return 0;
        } else if (this.state_id > other.state_id) {
            return 1;
        }
        return -1;
    }
}